"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var ColorGridWidget_1 = require("./ColorGridWidget");
var Declarative_1 = require("../utils/Declarative");
var react_1 = require("react");
var DropdownWidget_1 = require("./DropdownWidget");
var TabStyles_1 = require("../styles/TabStyles");
var GlobalPointerDownOutsideListener_1 = require("../utils/GlobalPointerDownOutsideListener");
var CustomColorInputWidget_1 = require("./CustomColorInputWidget");
var Overlay_1 = require("../utils/Overlay");
var getButtonColorRibbonStyle = function (props) {
    var buttonHeight = TabStyles_1.TabStyles.Sizing.RowHeight;
    var colorLabelHeight = buttonHeight * 0.5;
    return {
        display: 'inline-block',
        width: props.colorLabelWidth || 40,
        height: colorLabelHeight,
        boxSizing: 'border-box',
        backgroundColor: (props.color || '').toLowerCase(),
        marginTop: (buttonHeight - (colorLabelHeight + (TabStyles_1.TabStyles.Sizing.BorderWidth) * 2)) / 2
    };
};
var ColorPickerButton = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPickerButton, _super);
    function ColorPickerButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorPickerButton.prototype.render = function () {
        var buttonProps = {
            dropdownType: DropdownWidget_1.DropdownType.Outline,
            dropdownId: null,
            pointerClick: this.props.handleClick,
            onKeyDown: this.props.onKeyDown,
            dropdownOpen: this.props.isPickerOpen,
            disabled: this.props.disabled,
            interactiveStyles: DropdownWidget_1.getDropdownStylesByType(DropdownWidget_1.DropdownType.Outline).button.interactive,
            testId: Declarative_1.testId(this.props.testId, 'ColorPickerButton'),
            title: this.props.title
        };
        return (react_1.createElement(DropdownWidget_1.DropdownButtonWidget, buttonProps, react_1.createElement('div', { style: getButtonColorRibbonStyle(this.props) })));
    };
    return ColorPickerButton;
}(React.Component));
exports.ColorPickerButton = ColorPickerButton;
var ColorPickerWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPickerWidget, _super);
    function ColorPickerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.setColorPickerButton = function (component) {
            _this.buttonElement = ReactDOM.findDOMNode(component);
        };
        _this.unsubscribeOutsideClickListeners = function () {
            _this.outsideClickListenersUnsubscribe.forEach(function (callback) { return callback(); });
            _this.outsideClickListenersUnsubscribe = [];
        };
        _this.getAnchorClientRect = function () {
            return _this.buttonElement ? _this.buttonElement.getBoundingClientRect() : undefined;
        };
        _this.onColorSelected = function (color) {
            _this.togglePicker();
            _this.props.handleColorSelected(color.toLowerCase());
        };
        _this.togglePicker = function () {
            if (!_this.props.disabled) {
                _this.setState({ isPickerVisible: !_this.state.isPickerVisible });
            }
        };
        _this.togglePickerOnKeyEvent = function (e) {
            _this.togglePicker();
            e.preventDefault();
            e.stopPropagation();
        };
        // Handle key presses as defined by ARIA https://www.w3.org/TR/wai-aria-practices/#menu
        _this.handleKeyDown = function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                _this.togglePickerOnKeyEvent(e);
            }
        };
        _this.handleGridKeyUp = function (e) {
            if (e.key === 'Escape' && _this.state.isPickerVisible) {
                _this.togglePickerOnKeyEvent(e);
            }
        };
        _this.state = { isPickerVisible: false, customColorText: '' };
        _this.outsideClickListenersUnsubscribe = [];
        _this.colorGrid = null;
        return _this;
    }
    ColorPickerWidget.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (this.state.isPickerVisible && !prevState.isPickerVisible && this.colorGrid) {
            this.outsideClickListenersUnsubscribe = [this.colorGrid.parentElement, ReactDOM.findDOMNode(this)].map(function (elm) {
                return GlobalPointerDownOutsideListener_1.GlobalPointerDownOutsideListener.subscribe(elm, _this.togglePicker);
            });
            this.colorGrid.focus();
            if (this.state.customColorWidgetWidth !== this.colorGrid.clientWidth) {
                this.setState({ customColorWidgetWidth: this.colorGrid.clientWidth });
            }
        }
        else if (!this.state.isPickerVisible && prevState.isPickerVisible) {
            this.unsubscribeOutsideClickListeners();
        }
    };
    ColorPickerWidget.prototype.componentWillUnmount = function () {
        this.unsubscribeOutsideClickListeners();
    };
    ColorPickerWidget.prototype.render = function () {
        var buttonProps = {
            handleClick: this.togglePicker,
            color: this.props.selectedColor,
            disabled: this.props.disabled,
            isPickerOpen: this.state.isPickerVisible,
            colorLabelWidth: this.props.colorLabelWidth,
            onKeyDown: this.handleKeyDown,
            testId: this.props.testId,
            title: this.props.title,
            ref: this.setColorPickerButton
        };
        return (react_1.createElement('div', { style: { display: 'inline-block' }, 'data-tb-test-id': Declarative_1.testId(this.props.testId, 'ColorPicker') }, react_1.createElement(ColorPickerButton, buttonProps), Declarative_1.conditional(this.state.isPickerVisible, this.buildColorGridWidget())));
    };
    ColorPickerWidget.prototype.buildColorGridWidget = function () {
        var _this = this;
        var defaultCustomColorInputWidth = 100;
        var gridProps = {
            handleSwatchClicked: this.onColorSelected,
            selectedColor: (this.props.selectedColor || '').toLowerCase(),
            colorsPreset: this.props.colorsPreset,
            testId: 'colorgrid',
            ref: function (gridWidget) { return _this.colorGrid = ReactDOM.findDOMNode(gridWidget); }
        };
        var customColorInputProps = {
            onColorSelected: this.onColorSelected,
            color: this.getCustomColorInput(),
            testId: this.props.testId,
            width: this.state.customColorWidgetWidth || defaultCustomColorInputWidth
        };
        var overlayProps = {
            allowAutoPosition: true,
            anchorOrigin: {
                vertical: Overlay_1.VerticalOriginOption.bottom,
                horizontal: Overlay_1.HorizontalOriginOption.left
            },
            getAnchorClientRect: this.getAnchorClientRect,
            zIndex: this.props.dropdownZIndex,
        };
        var divWrapperProps = {
            style: {
                backgroundColor: TabStyles_1.TabStyles.Colors.White,
                zIndex: this.props.dropdownZIndex,
                position: 'absolute',
                padding: TabStyles_1.TabStyles.Spacing.LargeSpace,
                borderWidth: TabStyles_1.TabStyles.Sizing.BorderWidth,
                borderStyle: 'solid',
                borderColor: TabStyles_1.TabStyles.Colors.L5,
                borderRadius: TabStyles_1.TabStyles.Sizing.BorderRadius
            },
            onKeyUp: this.handleGridKeyUp,
            'data-tb-test-id': Declarative_1.testId(this.props.testId, 'ColorGridWrapper')
        };
        return react_1.createElement(Overlay_1.Overlay, overlayProps, react_1.createElement('div', divWrapperProps, react_1.createElement(ColorGridWidget_1.ColorGridWidget, gridProps), Declarative_1.conditional(this.props.showCustomColorInput, react_1.createElement('div', {}, react_1.createElement('hr', { style: { marginTop: TabStyles_1.TabStyles.Spacing.LargeSpace } }), react_1.createElement(CustomColorInputWidget_1.CustomColorInput, customColorInputProps)))));
    };
    ColorPickerWidget.prototype.getCustomColorInput = function () {
        var colors = this.props.colorsPreset === ColorGridWidget_1.ColorGridPreset.Light ?
            TabStyles_1.TabStyles.ColorPickerPresets.Light : TabStyles_1.TabStyles.ColorPickerPresets.Dark;
        return this.isSelectedColorCustom(colors) ? this.props.selectedColor : '';
    };
    ColorPickerWidget.prototype.isSelectedColorCustom = function (presetGridColors) {
        if (!this.props.selectedColor) {
            return false;
        }
        for (var _i = 0, presetGridColors_1 = presetGridColors; _i < presetGridColors_1.length; _i++) {
            var color = presetGridColors_1[_i];
            if (color.toLowerCase() === this.props.selectedColor.toLowerCase()) {
                return false;
            }
        }
        return true;
    };
    ColorPickerWidget.defaultProps = {
        shouldReturnFocusOnClose: true
    };
    return ColorPickerWidget;
}(React.Component));
exports.ColorPickerWidget = ColorPickerWidget;
//# sourceMappingURL=ColorPickerWidget.js.map